<!-- Delta Logo Template -->
<ng-template #deltaLogo>
  <svg
    width="80"
    height="64"
    viewBox="0 0 80 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_18482_46281"
      style="mask-type: alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="-8"
      width="80"
      height="72"
    >
      <rect y="-8" width="79.2453" height="72" fill="#C4C4C4" />
    </mask>
    <g mask="url(#mask0_18482_46281)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M78.2057 -8.01135L62.0235 14.7275L43.997 14.815L57.1839 1.78898L78.2057 -8.01135Z"
        fill="#E01933"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M34.1016 36.1808L22.5412 29.1015L26.9955 21.137L37.305 19.2447L34.1016 36.1808Z"
        fill="#E01933"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M44.0621 14.8803L49.2343 58.1151L78.3127 -7.98438L44.0621 14.8803Z"
        fill="#991933"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M22.5555 29.1348L45.017 64.681L37.3545 19.2578L22.5555 29.1348Z"
        fill="#991933"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M78.1606 -8.15473L7.58616 -7.73853L43.909 14.7105L78.1606 -8.15473Z"
        fill="#E01933"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0.00128355 -6.49024L22.4622 29.0552L37.2613 19.1782L0.00128355 -6.49024Z"
        fill="#E01933"
      />
    </g>
  </svg>
</ng-template>

<!-- Modal Header Template -->
<ng-template #modalHeader let-isDesktop="isDesktop" let-content="content">
  <div
    [class]="
      isDesktop
        ? 'pop-up-box-header flex items-center justify-between min-w-[327px] !p-0 border-none'
        : 'flex items-center !justify-between mb-8 border-none'
    "
  >
    <h2
      id="pop-up-title"
      class="flex self-end pl-[8px] text-heading-sm !leading-[5px] text-heading"
    >
      {{ content.staticContent.feedLabel }}
    </h2>
    <div [class]="isDesktop ? 'ml-auto flex items-center' : ''">
      <ng-container *ngTemplateOutlet="deltaLogo"></ng-container>
    </div>
    <button
      *ngIf="isDesktop"
      class="pop-up-box-header-close-button"
      (click)="close()"
      aria-label="Close pop-up"
      id="mach-core-notification-close-button"
    >
      <div class="pop-up-box-header-close-button-icon"></div>
    </button>
  </div>
</ng-template>

<div
  class="bell-icon__container bottom-[5px] border-r-0"
  id="mach-core-notification-container"
>
  <button
    tabindex="0"
    #triggerElement
    data-acdl-action="header:notification bell"
    data-acdl-name="notification bell"
    data-acdl-page-section="header:notification bell"
    (click)="open(); analyticsEventTracking(triggerElement)"
    [attr.aria-label]="
      facade.feedCounterValue > 0
        ? ((facade.notificationDetails$ | ngrxPush)?.staticContent?.label ||
            'Notifications') +
          ', ' +
          facade.feedCounterValue +
          ' unread'
        : (facade.notificationDetails$ | ngrxPush)?.staticContent?.label ||
          'Notifications'
    "
    class="bell-icon__container__icon-notification-icon relative w-8 h-8 cursor-pointer text-icon-inverse"
    id="mach-core-notification-bell"
  >
    <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.2623 26.9487C13.12 28.5096 14.2864 29.9951 15.9787 30C15.9884 30 15.9992 30 16.0089 30C17.7109 30 18.8785 28.5047 18.7338 26.9475L13.2623 26.9487ZM16.0788 2H15.9184C14.5276 2.29274 13.9631 2.99362 13.9619 4.42697C13.9607 5.49833 13.9607 5.49833 12.9559 5.85545C9.75817 6.99241 7.85835 9.52505 7.66777 12.8898C7.57489 14.5466 7.60383 16.2108 7.28177 17.8506C6.96815 19.437 6.60507 21.0234 5.65576 22.345C5.13226 23.0738 4.96218 23.7856 5.00681 24.6335C5.04782 25.4145 4.94167 25.4485 5.59425 25.4485C5.65938 25.4485 5.73055 25.4485 5.81137 25.4485H5.81378C9.15626 25.4485 12.4975 25.4497 15.84 25.4497C19.326 25.4497 22.8121 25.4485 26.2981 25.4485C26.9808 25.4485 26.9808 25.4473 26.982 24.761C26.982 24.7476 26.9808 24.7331 26.982 24.7197C27.0677 23.805 26.8481 23.024 26.3101 22.2296C25.2885 20.7197 24.9037 18.945 24.6407 17.157C24.4598 15.9265 24.4031 14.6875 24.391 13.4425C24.3536 9.5457 22.1969 6.70817 18.466 5.64045C18.1512 5.54935 18.0221 4.6201 18.0438 4.39295C18.1656 3.08594 17.3321 2.11175 16.0788 2ZM16.0463 5.91133C16.384 6.64257 16.9594 7.30944 17.9111 7.58275C20.7723 8.40146 22.2994 10.4106 22.3271 13.3939C22.344 15.0957 22.4345 16.4172 22.6191 17.6769C22.9025 19.601 23.3223 21.6259 24.4176 23.5062H15.8292H7.62917C8.55194 21.9089 8.94879 20.1828 9.27447 18.5345C9.56759 17.0465 9.62066 15.6192 9.67132 14.2393C9.68821 13.802 9.70389 13.3659 9.72802 12.9299C9.87156 10.4057 11.2189 8.61889 13.6266 7.76253C14.9088 7.3058 15.6579 6.77133 16.0463 5.91133Z"
        fill="currentColor"
      />
    </svg>

    <div
      *ngIf="facade.feedCounterValue > 0"
      class="feed-counter absolute top-0 right-0 tablet:right-[-3px] ultrawide:right-[-3px] box-content w-[15px] h-[15px] ml-[12px] rounded-[10px] bg-icon-alert"
      aria-hidden="true"
      id="mach-core-notification-counter"
    >
      <div
        class="feed-counter-text text-center text-[10px] font-['Whitney'] leading-[15px] text-inverse font-[375]"
      >
        {{ facade.feedCounterValue }}
      </div>
    </div>
  </button>
</div>

<!-- Combined Dialog Container -->
<ng-container *ngIf="facade.notificationDetails$ | ngrxPush as content">
  <!-- Desktop Dialog (>=768px) -->
  <dialog
    *ngIf="show && showModal === 'desktop'"
    id="notification-popup"
    class="pop-up"
    aria-labelledby="flyout-notification-header"
    aria-describedby="flyout-notification-description"
    aria-modal="true"
    role="dialog"
    #notificationFlyoutDesktop
  >
    <div
      [ngClass]="{
        'laptop:!max-h-[calc(100dvh-200px)]': isAlertAdvisory,
        'laptop:!max-h-[calc(100dvh-100px)]': !isAlertAdvisory
      }"
      class="pop-up-box w-[375px] !pt-0 pl-32 pr-16 !overflow-hidden"
      idpFlyoutPosition
    >
      <ng-container
        *ngTemplateOutlet="
          modalHeader;
          context: { isDesktop: true, content: content }
        "
      ></ng-container>
      <div class="pop-up-box-content !mt-20">
        <div class="flex flex-col px-8">
          <idp-notification-feed
            [content]="content || emptyNotificationDetails"
            (closeEvent)="close()"
            (newsEvent)="facade.getNews()"
          ></idp-notification-feed>
        </div>
      </div>
    </div>
    <form method="dialog" class="pop-up-backdrop">
      <button (click)="close()" aria-label="Close pop-up">Close</button>
    </form>
  </dialog>

  <!-- Mobile Dialog (<768px) -->
  <dialog
    *ngIf="show && showModal === 'mobile'"
    id="notification-mobile-popup"
    class="general-modal !p-0"
    aria-labelledby="flyout-notification-header"
    aria-describedby="flyout-notification-description"
    aria-modal="true"
    role="dialog"
    #notificationSearchMobile
  >
    <div
      class="general-modal-box !m-0 !w-full !max-w-none !h-[100vh] !max-h-full"
    >
      <div class="general-modal-header flex items-center justify-end">
        <button
          class="general-modal-close-button"
          (click)="close()"
          aria-label="Close modal"
        ></button>
      </div>
      <div class="general-modal-content !px-32 !pt-0">
        <ng-container
          *ngTemplateOutlet="
            modalHeader;
            context: { isDesktop: false, content: content }
          "
        ></ng-container>
        <idp-notification-feed
          [content]="content || emptyNotificationDetails"
          (closeEvent)="close()"
          (newsEvent)="facade.getNews()"
        ></idp-notification-feed>
      </div>
    </div>
    <form method="dialog" class="general-modal-backdrop">
      <button (click)="close()" aria-label="Close modal">Close</button>
    </form>
  </dialog>
</ng-container>
